/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type PermalinkViewContainer_comment = {
    readonly id: string;
    readonly status: COMMENT_STATUS;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_comment" | "ReplyListContainer1_comment">;
    readonly " $refType": "PermalinkViewContainer_comment";
};
export type PermalinkViewContainer_comment$data = PermalinkViewContainer_comment;
export type PermalinkViewContainer_comment$key = {
    readonly " $data"?: PermalinkViewContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'a495d802ce0cb53c058ea985991b080a';
export default node;
